export default class PromoCode {
  static TYPE_OPTIONS = [
    {label: 'Valor', value: 'value'},
    {label: 'Porcentagem', value: 'percentage'},
    {label: 'Dias gratuitos', value: 'free_days'}
  ]
}
